/**
 * @author        julian@zumper.com (Julian Napolitan)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   MobileAutocompleteInput Component
 */

import { cn } from '@zcode-ui/shadz-ui'
import React from 'react'
import { AUTOCOMPLETE_INPUT_ID } from '../constants'

import searchGray from '../../../../shared/components/svg/search_dark_gray.svg'

export interface SharedMobileAutocompleteInputProps {
  hideAutocomplete?: boolean
  isShortTerm?: boolean
  mobileOrigin?: string | null
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void
  placeholder?: string
}

const SharedMobileAutocompleteInput = ({
  hideAutocomplete,
  isShortTerm,
  mobileOrigin,
  placeholder,
  onClick,
}: SharedMobileAutocompleteInputProps) => {
  if (hideAutocomplete) {
    return null
  }

  return (
    <form className={cn('flex', 'items-center', 'h-full', 'relative', 'flex-auto')}>
      <img
        alt="search"
        className={cn(
          'h-5',
          'w-5',
          'absolute',
          'top-1/2',
          'left-[14px]',
          'z-1',
          'translate-y-[-50%]'
        )}
        loading="lazy"
        src={searchGray}
      />
      <label aria-label="autocomplete" className={cn('flex', 'items-center', 'w-full', 'h-full')}>
        <input
          className={cn(
            'w-full',
            'h-[calc(100%-4px)]',
            'py-0',
            'pr-0',
            'pl-[45px]',
            'text-base',
            '[line-height:calc(100%-4px)]',
            'border-0',
            '[border-radius:5px]',
            'appearance-none',
            'bg-gray-0',
            'overflow-hidden',
            'text-ellipsis',
            'whitespace-nowrap',
            'placeholder:text-[#0A0F1C]',
            'placeholder:align-center', // does this work? vertical-align: center;
            'placeholder:pl-10',
            'placeholder:text-left',
            isShortTerm ?? '[border:1px solid #ebeae6]'
          )}
          id={`${AUTOCOMPLETE_INPUT_ID}-${mobileOrigin}`}
          onClick={onClick}
          placeholder={placeholder}
          type="search"
        />
      </label>
    </form>
  )
}

export default SharedMobileAutocompleteInput
